import { FileDown } from "lucide-react";
import React from "react";
import "./index.css";

const PdfPage = ({ h1, h2, img, pdf1, pdf1Text, pdf2, pdf2Text }) => {
  return (
    <div className="pdf-modern-wrapper">
      <div className="pdf-modern-header">
        <h1 className="pdf-modern-main-heading">{h2}</h1>
        <h2 className="pdf-modern-subheading">{h1}</h2>
      </div>

      <div className="pdf-modern-grid">
        <div className="pdf-modern-download-section">
          {pdf1 && (
            <a
              href={pdf1}
              target="_blank"
              rel="noopener noreferrer"
              className="pdf-modern-download-button"
            >
              <div className="pdf-modern-button-content">
                <FileDown className="pdf-modern-icon" />
                <span className="pdf-modern-button-text">{pdf1Text}</span>
              </div>
              <div className="pdf-modern-badge">PDF</div>
            </a>
          )}
          {pdf2 && (
            <a
              href={pdf2}
              target="_blank"
              rel="noopener noreferrer"
              className="pdf-modern-download-button"
            >
              <div className="pdf-modern-button-content">
                <FileDown className="pdf-modern-icon" />
                <span className="pdf-modern-button-text">{pdf2Text}</span>
              </div>
              <div className="pdf-modern-badge">PDF</div>
            </a>
          )}
        </div>

        {img && (
          <div className="pdf-modern-logo-container">
            <div className="pdf-modern-logo-wrapper">
              <img
                src={img}
                alt="PSX Logo"
                width={400}
                height={400}
                className="pdf-modern-logo-image"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfPage;
